import styled from 'styled-components';
import WorkDeskSvg from '../../assets/amenities/work-desk.svg';

const WorkDeskIcon = styled(WorkDeskSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default WorkDeskIcon;
